import React, { useState, useEffect } from "react";
import FETCH from "../../../utils/fetch";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
import "../LiabilityDashboard.css";

export const LiabilityInfo = (props) => {
  const [loading, setLoading] = useState(false);
  console.log('props------------',props)

  function getLoanAmount(list, target) {
    if (!Array.isArray(list)) return "$0";
    const entry = list.find(
      (i) => i && i.module_name && i.module_name.toLowerCase() === target
    );
    return entry && entry.sum != null
      ? "$" + Number(entry.sum).toLocaleString(undefined, { minimumFractionDigits: 2 })
      : "$0";
  }
  
  function getOtherLoansSum(list) {
    if (!Array.isArray(list)) return "$0";
    const excluded = ["auto", "real estates", "student"];
    const total = list.reduce((acc, curr) => {
      
      const name = curr && curr.module_name && curr.module_name.toLowerCase();
      return name && !excluded.includes(name)
        ? acc + (curr.sum || 0)
        : acc;
    }, 0);
    return "$" + total.toLocaleString(undefined, { minimumFractionDigits: 2 });
  }

  function calculateCreditUtilization(creditRows) {
    if (!Array.isArray(creditRows)) return "N/A";
  
    const { balance, limit } = creditRows.reduce(
      (acc, row) => {
        const creditBalance = Number(row["Credit Balance"]);
        const creditLimit = Number(row["Credit Limit"]);
  
        acc.balance += !isNaN(creditBalance) ? creditBalance : 0;
        acc.limit += !isNaN(creditLimit) ? creditLimit : 0;
  
        return acc;
      },
      { balance: 0, limit: 0 }
    );
  
    if (balance === 0 || limit === 0) return "0.00%";
  
    const utilization = (balance / limit) * 100;
  
    return `${utilization.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}%`;
  }
  function calculateAverageInterestRate(creditRows) {
    if (!Array.isArray(creditRows) || creditRows.length === 0) return "N/A";
  
    const total = creditRows.reduce((sum, row) => {
      const rate = parseFloat(row["Interest Rate (or APR%)"]);
      return sum + (!isNaN(rate) ? rate : 0);
    }, 0);
  
    const avg = total / creditRows.length;
  
    return avg.toFixed(2) + "%";
  }
  const RowData = [
    {
      id: 1,
      name: "Total Credit Lines",
      "Number Credit Card and Loans": (props.total || 0) + (props.totalNoCredit || 0),
      "Total Amount Credit Cards and Loans":
        // props.totalAmount &&
        // `$${parseFloat(props.totalAmount)
        //   .toFixed(2)
        //   .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
        (props.totalLoan ||
          props.totalBalance) &&
          (parseFloat(props.totalLoan) + parseFloat(props.totalBalance))
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      "Total Monthly Payments":
        props.totalMonthly &&
        `$${parseFloat(props.totalMonthly)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
    },

    {
      id: 2,
      name: "Total Loan Balances",
      "Total Auto Loans":
        // props.totalAmountAll && props.totalAmountAll.auto
        //   ? `$${parseFloat(props.totalAmountAll.auto)
        //       .toFixed(2)
        //       .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
        //   : " $0",
        // (function () {
        //   const list = props.newLiabilitySum && props.newLiabilitySum.Liability;
        //   if (!Array.isArray(list)) return "$0";
        
        //   const entry = list.find((i) => i && i.module_name && i.module_name.toLowerCase() === "auto");
        //   return entry && entry.sum != null
        //     ? "$" + Number(entry.sum).toLocaleString(undefined, { minimumFractionDigits: 2 })
        //     : "$0";
        // })(),
        (function () {
          const list = props.newLiabilitySum && props.newLiabilitySum.Liability;
          if (!Array.isArray(list)) return "$0";
        
          const totalAutoSum = list.reduce((acc, curr) => {
            return curr.module_name && curr.module_name.toLowerCase() === "auto"
              ? acc + Number(curr.sum || 0)
              : acc;
          }, 0);
        
          return "$" + totalAutoSum.toLocaleString(undefined, { minimumFractionDigits: 2 });
        })(),
        // getLoanAmount(props.newLiabilitySum, "auto"),
      "Total Home Loans":
        // props.totalAmountAll && props.totalAmountAll.realEstate
        //   ? `$${parseFloat(props.totalAmountAll.realEstate)
        //       .toFixed(2)
        //       .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
        //   : " $0",
        // (function () {
        //   const list = props.newLiabilitySum && props.newLiabilitySum.Liability;
        //   if (!Array.isArray(list)) return "$0";
        
        //   const entry = list.find((i) => i && i.module_name && i.module_name.toLowerCase() === "real estates");
        //   return entry && entry.sum != null
        //     ? "$" + Number(entry.sum).toLocaleString(undefined, { minimumFractionDigits: 2 })
        //     : "$0";
        // })(),
        (function () {
          const list = props.newLiabilitySum && props.newLiabilitySum.Liability;
          if (!Array.isArray(list)) return "$0";
        
          const totalAutoSum = list.reduce((acc, curr) => {
            return curr.module_name && curr.module_name.toLowerCase() === "real estates"
              ? acc + Number(curr.sum || 0)
              : acc;
          }, 0);
        
          return "$" + totalAutoSum.toLocaleString(undefined, { minimumFractionDigits: 2 });
        })(),
        // getLoanAmount(props.newLiabilitySum, "real estates"),
      "Total Student Loans":
        // props.totalAmountAll && props.totalAmountAll.student
        //   ? `$${parseFloat(props.totalAmountAll.student)
        //       .toFixed(2)
        //       .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
        //   : " $0",
        // (function () {
        //   const list = props.newLiabilitySum && props.newLiabilitySum.Liability;
        //   if (!Array.isArray(list)) return "$0";
        
        //   const entry = list.find((i) => i && i.module_name && i.module_name.toLowerCase() === "student");
        //   return entry && entry.sum != null
        //     ? "$" + Number(entry.sum).toLocaleString(undefined, { minimumFractionDigits: 2 })
        //     : "$0";
        // })(),
        (function () {
          const list = props.newLiabilitySum && props.newLiabilitySum.Liability;
          if (!Array.isArray(list)) return "$0";
        
          const totalAutoSum = list.reduce((acc, curr) => {
            return curr.module_name && curr.module_name.toLowerCase() === "student"
              ? acc + Number(curr.sum || 0)
              : acc;
          }, 0);
        
          return "$" + totalAutoSum.toLocaleString(undefined, { minimumFractionDigits: 2 });
        })(),
        // getOtherLoansSum(props.newLiabilitySum),
      "Total Other Loans":
        // props.totalAmountAll && props.totalAmountAll.other
        //   ? `$${parseFloat(props.totalAmountAll.other)
        //       .toFixed(2)
        //       .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
        //   : " $0",
        // getOtherLoansSum(props.newLiabilitySum),
        (function(){
          const list = props.newLiabilitySum && props.newLiabilitySum.Liability;
          if (!Array.isArray(list)) return "$0";
          const excluded = ["auto", "real estates", "student"];
          const total = list.reduce((acc, curr) => {
            
            const name = curr && curr.module_name && curr.module_name.toLowerCase();
            return name && !excluded.includes(name)
              ? acc + (curr.sum || 0)
              : acc;
          }, 0);
          return "$" + total.toLocaleString(undefined, { minimumFractionDigits: 2 });
        })(),
    },
    {
      id: 3,
      name: "Total Credit Card Balances",
      // "Total Number of Cards": props.creditCount && props.creditCount,
      "Total Number of Cards": props.totalNoCredit && props.totalNoCredit,
      "Total Balances":
        // props.totalCountAndBalance &&
        // `$${parseFloat(props.totalCountAndBalance)
        //   .toFixed(2)
        //   .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
        (function () {
          if (!Array.isArray(props.creditRows)) return "$0";
        
          const total = props && props.creditRows.reduce((sum, row) => {
            const value = row["Credit Balance"];
            return sum + (typeof value === "number" ? value : 0);
          }, 0);
        
          return "$" + total.toLocaleString(undefined, { minimumFractionDigits: 2 });
        })(),
      "Total Credit Card Utilization":
        // props.totalCountAndBalance && props.totalCreditLimit
        //   ? `${((props.totalCountAndBalance / props.totalCreditLimit) * 100)
        //       .toFixed(2)
        //       .toString()
        //       .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}%`
        //   : "N/A",
        calculateCreditUtilization(props.creditRows),
      "Average Interest Rate":
        // props.averageInterestRate && props.creditCount
        //   ? (props.averageInterestRate / props.creditCount).toFixed(2) + "%"
        //   : "N/A",
        calculateAverageInterestRate(props.creditRows)
    },
    {
            id: 4,
            name: "Loan and Credit Card Details",
            "Highest Loan":
              // props.highestLoan &&
              // `$${parseFloat(props.highestLoan)
              //   .toFixed(2)
              //   .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
              props.liabilityCreditHigherValue && props.liabilityCreditHigherValue.max_initial_loan_amount &&
              `$${parseFloat(props.liabilityCreditHigherValue.max_initial_loan_amount)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
            "Highest Interest Rate": 
              // props.highestARP && `${props.highestARP + "%"}`,
              props.liabilityCreditHigherValue && props.liabilityCreditHigherValue.max_interest_rate && `${props.liabilityCreditHigherValue.max_interest_rate + "%"}`,
            "Highest Monthly Payment":
            // props.highestMonthly &&
            //   `${
            //     "$" +
            //     props.highestMonthly.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            //   }`,
            props.liabilityCreditHigherValue && props.liabilityCreditHigherValue.max_monthly_payment &&
              `${
                "$" +
                props.liabilityCreditHigherValue.max_monthly_payment
              }`,
            "Average Credit Age": props.totalMonthDiff
              ? formatMonths(props.totalMonthDiff)
              : "N/A",
          },
  ];
  const moduleStateMapping = {
    Student: "student",
    Auto: "auto",
    "Real Estates": "realEstate",
    // Add more mappings if needed
  };
  function formatMonths(totalMonths) {
    // Calculate years and remaining months
    const years = Math.floor(totalMonths / 12);
    const months = (totalMonths % 12).toFixed(2);
    console.log("calling function", totalMonths);
    // Construct the formatted string
    let result = "";
    if (years > 0) {
      result += `${years} year${years > 1 ? "s" : ""}`;
    }
    if (months > 0) {
      result += ` ${months} month${months > 1 ? "s" : ""}`;
    }
    console.log("result", result.trim());
    return result.trim();
  }

  return (
    <React.Fragment>
      {RowData &&
        RowData.map((item, index) => (
          <div
            key={index}
            className="liablityInfocard"
            style={{ position: "relative" }}
          >
            <h3 className="liablitycardheading">{item.name}</h3>
            {Object.keys(item).map(
              (key, subIndex) =>
                key !== "name" &&
                key != "id" && (
                  <div key={subIndex}>
                    <div className="inforow" style={{ border: "none" }}>
                      <div
                        className="inforowData"
                        style={{
                          flexDirection: "row",
                          width: "100%",
                          alignItems: "center",
                          gap: "4%",
                          justifyContent: "left",
                        }}
                      >
                        <span className="infoTitle1"> {key}:</span>
                        <span className="infosubTitle">
                          {/* {typeof item[key] === "number" ? `$ ${item[key]}` : item[key]} */}
                          {item[key]}
                        </span>
                      </div>
                    </div>
                  </div>
                )
            )}
            <NewLoader isLoading={props.loading} />
          </div>
        ))}
    </React.Fragment>
  );
};
